import { assert_string_object_id_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_IMAGE_META__base } from '../_base/DTO_IMAGE_META__base';
import { INTERFACE_IMAGE_META__grid2d_cell } from './INTERFACE_IMAGE_META__grid2d_cell';

export class DTO_IMAGE_META__grid2d_cell_collection extends DTO_IMAGE_META__base implements INTERFACE_IMAGE_META__grid2d_cell {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.IMAGE_META__GRID2D_CELL_COLLECTION;

  /*
   * STATIC METHODS
   */

  static filter_by_type(items: DTO_IMAGE_META__base[]) {
    return items.filter(item => item instanceof DTO_IMAGE_META__grid2d_cell_collection);
  }

  /*
   * FIELDS
   */

  grid2d_id!: string;
  grid2d_type!: ENUM__workspace_entity;
  grid2d_chunk_id!: string;

  /*
   * RUNTIME FIELDS
   */

  /*
   * PROPERTIES
   */

  /*
   * METHODS
   */
  constructor() {
    super();
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_object_id_not_empty(this.grid2d_id);
    assert_type_enum(this.grid2d_type, ENUM__workspace_entity);
    assert_string_object_id_not_empty(this.grid2d_chunk_id);
  }
}
